import { useSelector } from "react-redux";
import { getCategoryId } from "../../../../../../state/modules/category";
import { getCountryCode } from "../../../../../../state/modules/config/selectors";
import commonConfig from "../../../../../../config/common";

import visualLinksConfig from "./visualLinksConfig";

const useVisualCategoryHeaderLinks = () => {
  const { visualCategoryHeaderLinkCountries } = commonConfig;
  const countryCode = useSelector(getCountryCode);

  return (
    visualCategoryHeaderLinkCountries.includes(countryCode) &&
    !!visualLinksConfig[useSelector(getCategoryId)]
  );
};

export default useVisualCategoryHeaderLinks;
